module.exports = __webpack_public_path__ + "static/media/img2-2.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/biosense/diff/img2-2.png
// module id = 1738
// module chunks = 3